export default "__VITE_ASSET__5ec85f3d__"